import { Link } from "@tanstack/react-router";
import icon1 from "@/assets/icon_1.png.asset.json";
import icon2 from "@/assets/icon_2.png.asset.json";
import icon3 from "@/assets/icon_3.png.asset.json";
import icon4 from "@/assets/icon_4.png.asset.json";

type Tile = {
  num: string;
  title: string;
  to: string;
  icon: string;
  bullets: string[];
};

const tiles: Tile[] = [
  {
    num: "1.",
    title: "Was ist\nEnergy Prime 360?",
    to: "/was-ist-energy-prime-360",
    icon: icon1.url,
    bullets: [
      "Unabhängiges Analyse- und Vergleichsportal",
      "Kostenlos und herstellerneutral",
      "Alle relevanten Faktoren im Blick",
      "Die beste Entscheidung für Ihr Projekt",
    ],
  },
  {
    num: "2.",
    title: "Was analysiert\nEnergy Prime 360?",
    to: "/was-analysieren-wir",
    icon: icon2.url,
    bullets: [
      "Technik, Wirtschaftlichkeit & Energie",
      "Fördermittel, Finanzierung & Steuern",
      "Risiken, Potenziale & Zukunftsperspektiven",
      "Alles im Zusammenspiel analysiert",
    ],
  },
  {
    num: "3.",
    title: "Was vergleichen\nwir für Sie?",
    to: "/was-vergleichen-wir",
    icon: icon3.url,
    bullets: [
      "Angebote, Hersteller & Produkte",
      "Kosten, Qualität & Leistungen",
      "Förderungen, Finanzierungen & Steuern",
      "10, 20 & 30 Jahre im Vergleich",
    ],
  },
  {
    num: "4.",
    title: "Was erhalten Sie\nals Ergebnis?",
    to: "/ergebnis",
    icon: icon4.url,
    bullets: [
      "Vollständige Analyse & Bewertung",
      "Individuelle Handlungsempfehlung",
      "10, 20 & 30 Jahre Prognosen",
      "Ihre fundierte Entscheidungsgrundlage",
    ],
  },
];

export function PublicTiles() {
  return (
    <section className="surface-sky border-b border-[var(--rule)]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {tiles.map((t) => (
            <article
              key={t.num}
              className="group bg-white rounded-xl border border-[var(--rule)] shadow-md hover:shadow-xl transition-shadow p-6 flex flex-col"
            >
              <div className="flex items-start gap-3 mb-3">
                <div
                  className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${
                    t.num === "2." ? "bg-[var(--leaf)]" : ""
                  }`}
                >
                  <img
                    src={t.icon}
                    alt=""
                    width={40}
                    height={40}
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <div>
                  <div className="text-orange font-display font-semibold text-sm">
                    {t.num}
                  </div>
                  <h3 className="font-display font-bold text-navy text-lg leading-tight whitespace-pre-line">
                    {t.title}
                  </h3>
                </div>
              </div>
              <ul className="mt-2 space-y-2 text-[13.5px] text-navy/85 flex-1">
                {t.bullets.map((b) => (
                  <li key={b} className="flex gap-2">
                    <svg viewBox="0 0 24 24" className="w-4 h-4 text-[var(--leaf-deep)] shrink-0 mt-0.5" fill="currentColor" aria-hidden>
                      <path d="M9 16.2l-3.5-3.6L4 14.1 9 19l11-11-1.5-1.5z" />
                    </svg>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
              <Link
                to={t.to}
                className="mt-5 inline-flex items-center justify-between text-navy font-medium text-sm hover:gap-3 transition-all"
              >
                Mehr erfahren
                <span className="inline-flex w-7 h-7 items-center justify-center rounded-full bg-navy text-white text-base">
                  →
                </span>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
